export const AutodeskConstants = {
	Extensions: {
		Selector: "SelectorExtension",
		Floor: "FloorSelectorExtension",
		ContextMenu: "ContextMenuExtension",
		Toolbar: "ToolbarExtension",
		ViewControl: "ViewControlExtension",
		Camera: "CameraExtension",
		Click: "ClickExtension",
	},
	Elements: {
		PopupContainerId: "autodesk-popup-container",
	},
};
